module.exports = __webpack_public_path__ + "img/ic-dankort-no-color.9c942e2d.svg";